import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import Renderer, { getData, } from '../Renderer';
import PlaceHolder from '../../portal/common/PlaceHolder';
import { passesConditions } from '../displayConditions';
const ConditionalWidget = ({ 
// expect to have 0 or 1 items
items, conditions, data, context, editData, configId, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
config, }) => {
    console.log('ConditionalWidgetConfig', {
        items,
        conditions,
    });
    const store = useStore();
    const { currentCustomer, currentAccess } = store;
    const canAdd = editData && editData.actions && editData.actions.canEdit(configId);
    const isEmpty = () => ((!items || !items[0]) && editData);
    const requestContext = {
        customer: currentCustomer || null,
        accessGroups: currentAccess?.groups || [],
    };
    return (_jsxs(Box, { children: [(editData || passesConditions(conditions, requestContext))
                && items && items[0] && (_jsx(Renderer, { configId: items[0], data: data, context: context, editData: editData }, items[0])), canAdd && _jsx(editData.DropTarget, { dropId: `${configId}@0`, editData: editData }), isEmpty() && (_jsx(PlaceHolder, { placeHolderName: "Configure Conditional Widget" }))] }));
};
ConditionalWidget.getData = ({ items, 
// could make loading data conditional
// eslint-disable-next-line @typescript-eslint/no-unused-vars
conditions, data, context, editData, }, store) => (Promise.allSettled([
    ...items.map((itemId) => (getData({
        configId: itemId,
        data,
        context,
        editData,
    }, store))),
]));
const meta = {
    group: 'layouts',
    name: 'Conditional',
    description: 'Displays child widget if all the conditions are met.',
    props: [
        {
            key: 'conditions',
            name: 'Conditions',
            type: 'displayCondition',
            description: 'Conditions for the display of the widget.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'ConditionalWidget',
        editProps: {},
        props: {
            items: [],
            conditions: {
                loggedIn: true,
                accessGroups: {},
            },
        },
    },
    getChildren: (config) => (config.props.items || []),
};
ConditionalWidget.meta = meta;
export default observer(ConditionalWidget);
//# sourceMappingURL=ConditionalWidget.js.map